/**
 * interact.js 1.10.14
 *
 * Copyright (c) 2012-present Taye Adeyemi <dev@taye.me>
 * https://interactjs.io/license
 */
